<!-- <ion-header class="header-item">
  <ion-toolbar class="ion_tool_bar_css">
    <ion-buttons slot="start" class="mrglft5pt">
      <ion-icon
        name="arrow-back"
        class="icon_left"
        (click)="closeBtnClick()"
      ></ion-icon>
    </ion-buttons>
    <span class="headerText">Select user</span>
  </ion-toolbar>
</ion-header> -->
<app-app-header [showBackBtn]="showBackBtn" [title]="pageTitle" (click)="closeBtnClick()"></app-app-header>

<!-- <div class="searchTitle">Search</div> -->


<!-- <div class="searchbar-border">
  <ion-searchbar style="border: 1px solid #686868;
    border-radius: 10px;
    color: #9E9E9E;
    font-family: 'Nunito';
    font-size: 14px;
    font-weight: 325;" 
      placeholder="Search in country directory"
      
      [formControl]="searchControl"
      id="searchText"    
      showClearButton="always"  
      (click)="onSearchClick()"      
    ></ion-searchbar>
</div> -->
<div class="search-input-container" (click)="onSearchClick()">
    <ion-icon name="search" class="search-icon"></ion-icon>
    <div class="search-text-placeholder">Search in country directory</div>
    <ion-icon name="close-circle" class="manual-close-icon"></ion-icon>
  </div>

<div class="siteManagerTitle">Site Manager</div>
<div class="addSidePadding" >
  <div class="recentEmail" (click)="onCountryDirectoryClick()" *ngIf="site_manager?.id; else noManager">
    {{ site_manager.id }}
  </div>

  <ng-template #noManager>
    <div class="recentEmail">No site manager Assigned</div>
  </ng-template>
</div>

<div class="recentSelected">Zone Owner</div>
<div class="addSidePadding">
  <div class="recentEmail"  *ngIf="appService?.currentTour?.currentBogTourInfo?.zoneConfiguration?.zoneOwner?.email; else noAreaOwner" (click)="onAreaOwnerClick()">
    {{appService?.currentTour?.currentBogTourInfo?.zoneConfiguration?.zoneOwner?.email}}
  </div>

  <ng-template #noAreaOwner>
    <div class="recentEmail">No zone owner assigned</div>
  </ng-template>
</div>

<div class="recentSelected">Recently Selected</div>

<div class="addSidePaddingForRecent" *ngIf="category == 'add-discussed-user'" >
  <div 
    class="recentEmail"
    *ngFor="let user of lastFiveDiscussedUser"
    (click)="userSelected(user)"
  > {{ user?.Email }}
  </div>
</div>
<div class="addSidePaddingForRecent"  *ngIf="category == 'add-action'" >
  <div
    class="recentEmail"
    *ngFor="let user of lastFiveAssignedUserList"
    (click)="userSelected(user)"
  > {{ user?.Email }}
  </div>
</div>






